import { Slider, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useStateWithSearchParams, useDebounceValue } from "../../../hooks";

const marks = [
  { value: 0 },
  { value: 20 },
  { value: 40 },
  { value: 50 },
  { value: 60 },
  { value: 80 },
  { value: 100 },
];

type SearchParams = {
  min?: string;
  max?: string;
};

export const SliderBlock = ({
  total_members,
  page,
  setPage,
}: {
  total_members: number;
  page: number;
  setPage: (page: number) => void;
}) => {
  const { searchDict, setSearchValue } = useStateWithSearchParams<SearchParams>(
    {
      min: undefined,
      max: undefined,
    },
  );

  const min = searchDict.min ? Number(searchDict.min) : 0;
  const max = searchDict.max ? Number(searchDict.max) : 100;

  const [range, setRange] = useState<number[]>([min, max]);
  const debounceRange = useDebounceValue(range);

  useEffect(() => {
    if (max !== debounceRange[1]) {
      setSearchValue(
        "max",
        debounceRange[1] === 100 ? undefined : debounceRange[1],
      );
      page && setPage(0);
    }
  }, [debounceRange[1]]);

  useEffect(() => {
    if (min !== debounceRange[0]) {
      setSearchValue("min", debounceRange[0] || undefined);
      page && setPage(0);
    }
  }, [debounceRange[0]]);

  const handleSliderChange = (event: Event, newValue: number | number[]) => {
    const [newMin, newMax] = newValue as number[];

    if (newMin >= newMax) return;
    setRange([newMin, newMax]);
  };

  return (
    <Stack sx={{ width: "288px" }} gap="6px">
      <Typography variant="caption" color="custom.textDarkBlue">
        Show results in a probability range
      </Typography>
      <Stack flexDirection="row" gap={2} alignItems={"center"} minHeight="36px">
        <Typography variant="body1" color="custom.textDarkBlue">
          0
        </Typography>
        <Slider
          disabled={total_members === 0 && range[0] === 0 && range[1] === 100}
          value={range}
          onChange={handleSliderChange}
          step={5}
          marks={marks}
          valueLabelDisplay="auto"
          min={0}
          max={100}
          sx={{
            color: "#1C3C6C",
            "& .MuiSlider-rail": {
              bgcolor: "#D9D9D9",
            },
            "& .MuiSlider-thumb": {
              width: 20,
              height: 20,

              "&:focus, &:hover, &.Mui-active": {
                boxShadow: "0px 0px 0px 8px rgba(0, 0, 255, 0.2)",
              },
            },
            "& .MuiSlider-valueLabel": {
              width: 41,
              height: 30,
              borderRadius: "4px",
              backgroundColor: "#757575",
            },
          }}
        />
        <Typography variant="body1" color="custom.textDarkBlue">
          100
        </Typography>
      </Stack>
    </Stack>
  );
};
